import { Button, Paper, Stack, Text } from 'shell/components';
import FeedbackSettingsDetails, { getFeedbackTypeName } from './FeedbackSettingsDetails';

const AssignmentFeedbackSettingsSummary = ({ settings, additionalInstructions, onCopy, isCopyDisabled, t }) => (
    <Paper variant={'outlined'}>
        <Stack spacing={3}>
            <Text weight={'medium'}>
                {t('feedback-section.settings.copy-title', 'Copy Assignment Feedback Settings')}
            </Text>
            <Text color={'light'}>
                {t(
                    'feedback-section.settings.copy-description',
                    'Use the advanced feedback settings already established for this assignment. These will replace the settings listed below.'
                )}
            </Text>
            <Paper sx={(theme) => ({ background: theme.palette.ensightful.neutral[50] })} variant={'outlined'}>
                <Stack spacing={3}>
                    <Text weight={'semibold'}>{getFeedbackTypeName(settings, t)}</Text>
                    <Stack spacing={2} sx={{ pl: 4 }}>
                        <FeedbackSettingsDetails
                            settings={settings}
                            additionalInstructions={additionalInstructions}
                            t={t}
                        />
                    </Stack>
                </Stack>
            </Paper>
            <Stack direction={'row'} justifyContent={'flex-start'} alignItems={'center'} spacing={3}>
                <Button disabled={isCopyDisabled} onClick={onCopy}>
                    {t('common:controls.copy-settings', 'Copy Settings')}
                </Button>
            </Stack>
        </Stack>
    </Paper>
);

export default AssignmentFeedbackSettingsSummary;
